import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

interface SortableRowProps {
    id: string;
    children: React.ReactNode;
    className?: string;
    isSorting?: boolean;
    readOnly?: boolean;
    hideDragHandle?: boolean;
}

export function SortableRow({ id, children, className, isSorting, readOnly, hideDragHandle }: SortableRowProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 50 : 'auto',
        position: isDragging ? 'relative' as const : undefined,
    };

    return (
        <tr
            ref={setNodeRef}
            style={style}
            className={`group ${className || ''} ${isDragging ? 'opacity-50 bg-slate-100 shadow-lg' : ''} ${isSorting ? 'cursor-grabbing' : ''} transition-colors duration-150 hover:bg-slate-50`}
        >
            {!hideDragHandle && (
                readOnly ? (
                    <td className="p-0 px-1 w-8 min-w-[32px] text-slate-200 text-center select-none" title="전체 교재 목록에서는 순서를 변경할 수 없습니다.">
                        <GripVertical size={14} className="mx-auto opacity-20" style={{ pointerEvents: 'none' }} />
                    </td>
                ) : (
                    <td className="p-0 px-1 w-8 min-w-[32px] cursor-grab text-slate-300 hover:text-slate-500 active:cursor-grabbing text-center" style={{ touchAction: 'none' }} {...attributes} {...listeners}>
                        <GripVertical size={14} className="mx-auto" style={{ pointerEvents: 'none' }} />
                    </td>
                )
            )}
            {children}
        </tr>
    );
}
